import authService from '@/services/authService';
import { Spin } from 'antd';
import React from 'react';

export default function LogoutPage() {
  React.useEffect(() => {
    setTimeout(() => {
      authService.clearInfoWhenLogout().finally(() => {
        window.location.href = '/cms/login';
      });
    }, 300);
  }, []);
  return (
    <Spin spinning tip="ログアウトしています">
      <div style={{ width: '100vw', height: '100vh' }}></div>
    </Spin>
  );
}
